// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<section id="customer-loans-edit" class="box">
  <sub-header header="'Edit loan co-makers'"></sub-header>

  <customer-loan-co-makers
    form="\$ctrl.form"
    edit-mode="true"
    loan="\$ctrl.loan">
  </customer-loan-co-makers>

  <div class="buttons">
    <button type="button" class="btn btn-warning" ng-click="\$ctrl.redirectBack()">Cancel</button>
    <button class="btn btn-primary"
            ng-click="\$ctrl.save()"
            command-access="EditLoanCoMakers"
            ng-disabled="\$ctrl.form.\$invalid">
      Save
    </button>
  </div>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/edit/customer-loans-edit-co-makers.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;